import styled from 'styled-components';

interface StyledWireLineProps {
	$from: number;
	$to: number;
	$positions: {
		top: number;
		gap: number;
	};
	$mousePosition?: {
		x: number;
		y: number;
	};
	$color: {
		start: string;
		end: string;
	};
	$zoomFactor: number;
	$draggingSide?: 'left' | 'right';
}

const WIRE_HEIGHT = 60;
const WIRE_CENTER_OFFSET = WIRE_HEIGHT / 2;

const calculateWireStyles = ({
	$from,
	$to,
	$positions,
	$mousePosition,
	$zoomFactor,
	$draggingSide,
}: StyledWireLineProps) => {
	const startY = $positions.top + $from * ($positions.gap + WIRE_HEIGHT);
	const endY = $mousePosition
		? $mousePosition.y / $zoomFactor - 30
		: $positions.top + $to * ($positions.gap + WIRE_HEIGHT);

	const startX = $draggingSide === 'right' ? 740 : 280;
	const endX = $mousePosition
		? $mousePosition.x / $zoomFactor
		: $draggingSide === 'right'
		? 280
		: 740;

	const length = Math.sqrt(
		Math.pow(endX - startX, 2) + Math.pow(endY - startY, 2),
	);
	const angle = Math.atan2(endY - startY, endX - startX) * (180 / Math.PI);

	return {
		width: `${length}px`,
		left: `${startX}px`,
		top: `${startY + WIRE_CENTER_OFFSET - 5}px`,
		transform: `rotate(${angle}deg)`,
	};
};

const StyledContainer = styled.div`
	position: absolute;
	width: 100%;
	height: 629px;
	background-color: rgba(0, 0, 0, 0.2);
`;

const StyledWiresContainer = styled.div`
	position: absolute;
	display: flex;
	flex-direction: column;
`;

const StyledWireContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

const StyledWireLine = styled.div.attrs<StyledWireLineProps>((props) => ({
	style: calculateWireStyles(props),
}))<StyledWireLineProps>`
	position: absolute;
	height: 10px;
	background: linear-gradient(
			90deg,
			rgba(255, 255, 255, 0) 0%,
			rgba(255, 255, 255, 0.25) 49.52%,
			rgba(255, 255, 255, 0) 100%
		),
		rgba(255, 255, 255, 0.1);
	transform-origin: left center;
	pointer-events: none;

	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: linear-gradient(
				90deg,
				rgba(255, 255, 255, 0) 0%,
				rgba(255, 255, 255, 0.25) 49.52%,
				rgba(255, 255, 255, 0) 100%
			),
			rgba(255, 255, 255, 0.1);
		opacity: 0.3;
	}
`;

export {
	StyledContainer,
	StyledWireContainer,
	StyledWireLine,
	StyledWiresContainer,
};
